import langs from "./languages";

export const index = {
  languages: langs,
};

export default index;
